import { createSelector } from 'reselect'

import { IWelcomeFlowUserData } from '../types'

import { selectWelcomeFlowState } from './selectWelcomeFlowState'

export const selectWelcomeFlowUserData = createSelector([selectWelcomeFlowState], (state) => {
  if (!state.UserData.length) {
    return {
      ManagerEmail: '',
      BusinessUnit: '',
      Email: '',
      FirstName: '',
      LastName: '',
      Roles: '',
      RTM: 'Reseller',
    } as IWelcomeFlowUserData
  }

  return state.UserData[0]
})
